export const tracker = (event, payload = null) => {
  window.postMessage({
    name: 'iConnectionsEventBus',
    type: 'tracker',
    event,
    payload: JSON.parse(JSON.stringify(payload)),
  }, '*');
};

export default tracker;
